import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, ViewChildren, ElementRef, HostListener } from '@angular/core';
import { BranchService } from 'src/app/core/services/branch.service';
import { MatDialog, MatSelect } from '@angular/material';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Subscription, ReplaySubject, Subject } from 'rxjs';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Router } from '@angular/router';
import { UploadMultiFileComponent } from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import { NgForm, FormControl } from '@angular/forms';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { DeactivationGuarded } from 'src/app/core/guards/confirm-deactivate.guard';
import { map, first, takeUntil } from 'rxjs/operators';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { AutocompleteComponent } from 'src/app/shared/components/autocomplete/autocomplete.component';
import { ApiService } from 'src/app/core/services/api.service';
import Utils from 'src/app/core/services/app-utils';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Common } from '../../../../../../core/constants/common';

@Component({
  selector: 'app-add-branch',
  templateUrl: './add-branch.component.html',
  styleUrls: ['./add-branch.component.scss']
})

export class AddBranchComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, DeactivationGuarded {
  // set max date for birthday
  maxDate = new Date();
  minDate = new Date(1899, 12, 1);


  branch = {
    parentId: localStorage.getItem('enterpriseId'),
    tenantId: localStorage.getItem('tenantId'),
    name: '',
    foreignName: '',
    abbreviation: '',
    taxCode: '',
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: '',
    issuedAt: '',
    accountNumber: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedOn: '',
    birthday: '',
    sex: null,
    businessType: null,
    enterpriseType: null,
    status: true,
    isDeleted: null,
    attachments: [],
    addresses: [
      {
        cityId: null,
        wardId: null,
        districtId: null,
        address: ''
      }
    ]
  };
  checkFocus = true;
  cities: comboBox[] = [];
  districts: districtsComboBox[] = [];
  selectedDistricts: districtsComboBox[] = [];
  wards: wardsCombobox[] = [];
  selectWards: wardsCombobox[] = [];
  show = true;

  maxLengthPhone = Common.MAX_LENGTH_PHONE;

  // Error message to display
  error = '';
  // Variable to subscribe to error
  subscription: Subscription;

  // List all parent branches
  parentBranches: { id: string, name: '' }[];
  // Selected model value for autocomplete
  selectedBranch: { id: string, name: '' };
  @ViewChild(AutocompleteComponent, { read: AutocompleteComponent, static: true }) autocompleteComponent;
  @ViewChild('certificationTypeSelect', { static: false }) certificationTypeSelect: MatSelect;
  @ViewChild('representativeCertificateSelect', { static: false }) representativeCertificateSelect: MatSelect;
  @ViewChild('citySelect', { static: false }) citySelect: MatSelect;
  @ViewChild('districtSelect', { static: false }) districtSelect: MatSelect;
  @ViewChild('wardSelect', { static: false }) wardSelect: MatSelect;
  @ViewChild('sexSelect1', { static: false }) sexSelect1: MatSelect;
  @ViewChild('certificateNoEl', { static: false }) certificateNoEl: ElementRef;

  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  // Whether the form change or not
  isFormChanging = false;
  certificateType: comboBox[] = [];
  representativeCertificateType: comboBox[] = [];
  listFile: any[];

  certificateTypeFilterCtrl: FormControl = new FormControl();
  representativeCertificateTypeFilterCtrl: FormControl = new FormControl(); cityFilterCtrl: FormControl = new FormControl();
  districtsFilterCtrl: FormControl = new FormControl();
  wardFilterCtrl: FormControl = new FormControl();
  urlApi = '/enterprises/branch/';
  public filteredWard: ReplaySubject<wardsCombobox[]> = new ReplaySubject<wardsCombobox[]>(1);
  public filteredDistricts: ReplaySubject<districtsComboBox[]> = new ReplaySubject<districtsComboBox[]>(1);
  public filteredCity: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredCertificateType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  public filteredRepresentativeCertificateType: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  private _onDestroy = new Subject<void>();

  /**
   *
   * Check if District hasn't Ward
   */
  notHasWard = false;
  @ViewChild(UploadMultiFileComponent, { read: UploadMultiFileComponent, static: false }) uploadMultiFileComponent;
  @ViewChildren('focusInput') focusInput;
  @ViewChildren('focusInputCer') focusInputCer;
  @ViewChildren('focusTaxcode') focusTaxcode;
  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    private apiService: ApiService,
    private el: ElementRef,
    private branchService: BranchService,
    public commonService: CommonService,
    public notificationService: NotificationService,
    private dialog: MatDialog,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    public message: Message,
    private toastr: ToastrService,
    public customerFilter: CustomerFilterLanguage
  ) {
    super(commonService, message);
  }

  /**
   * Get initial data
   */
  ngOnInit() {
    document.getElementById("idBranchName").focus();
    this.apiService.addUrlToHandlingErrorRestApis(this.urlApi);
    this.certificateTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.certificateType, this.certificateTypeFilterCtrl, this.filteredCertificateType);
      });

    this.representativeCertificateTypeFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(
          this.representativeCertificateType,
          this.representativeCertificateTypeFilterCtrl,
          this.filteredRepresentativeCertificateType);
      });

    this.cityFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.cities, this.cityFilterCtrl, this.filteredCity);
      });

    this.districtsFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.selectedDistricts, this.districtsFilterCtrl, this.filteredDistricts);
      });

    this.wardFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.commonService.filterCertificateType(this.selectWards, this.wardFilterCtrl, this.filteredWard);
      });

    this.getCertificateType();
    this.getRepresentativeCertificateType();
    this.loadCities();
    this.loadDistricts();
    this.loadWards();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'main', params: [], highlight: false},
      { label: 'breadcrumbs.enterprise_manage', url: '', params: [], highlight: false},
      { label: 'breadcrumbs.branch', url: 'branches', params: [], highlight: false },
      { label: 'breadcrumbs.branch_add', url: 'add-branch', params: [], highlight: false },
    ]);
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.formChangesSubscription.unsubscribe();
    this.apiService.removeUrlToHandlingErrorRestApis();
  }

  /**
   * Get cities list from local storage or api
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
      this.commonService.getAllCityRedis().subscribe(rs => {
        this.cities = rs.data;
        localStorage.setItem(
          'cities',
          JSON.stringify(this.cities),
        );
        this.filteredCity.next(this.cities.slice());
      });
    // } else {
    //   this.cities = JSON.parse(
    //     localStorage.getItem('cities')
    //   );
    //   this.filteredCity.next(this.cities.slice());
    // }
  }

  /**
   * Get districts list from local storage or api
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
      this.commonService.getAllDistrictsRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.districts = data;
          localStorage.setItem(
            'districts',
            JSON.stringify(this.districts),
          );
        }
      });
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Get wards list from local storage or api
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
      this.commonService.getAllWardRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.wards = data;
          localStorage.setItem(
            'wards',
            JSON.stringify(this.wards),
          );
        }
      });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  /**
   * Get parent branches for creating branch
   */
  getParentBranches() {
    this.branchService.getParentBranches(this.branch.parentId).subscribe(
      rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        this.parentBranches = rs.data;
        this.selectedBranch = this.parentBranches.find(x => {
          return x.id === this.branch.parentId;
        });
        this.autocompleteComponent.formControl.setValue({ id: this.selectedBranch.id, name: this.selectedBranch.name });
      }
    );
  }

  /**
   * Detect change on city or district combobox
   * @param value: id of city or district
   * @param opt: option for changing city or district
   */
  onChange(value: number, opt: number = 1) {
    switch (opt) {
      case 1:
        this.selectedDistricts = this.districts.filter(x => {
          this.selectWards = null;
          this.branch.addresses[0].districtId = null;
          this.branch.addresses[0].wardId = null;
          return x.cityId == value;
        });
        this.filteredDistricts.next(this.selectedDistricts.slice());
        this.filteredWard = new ReplaySubject<wardsCombobox[]>(1);
        break;
      case 2:
        this.selectWards = this.wards.filter(x => {
          this.branch.addresses[0].wardId = null;
          return x.districtId == value;
        });
        this.filteredWard.next(this.selectWards.slice());
        if (this.selectWards.length === 0) {
          this.notHasWard = true;
        } else {
          this.notHasWard = false;
        }
        break;
      default:

        break;
    }
  }

  /**
   * Detect value changing in autocomplete input
   */
  onChangeAutoCompleted() {
    if (this.selectedBranch == null || this.selectedBranch == undefined) {
      this.branch.parentId = '';
    } else if (this.selectedBranch != null && this.selectedBranch != undefined) {
      this.ngForm.control.markAsDirty();
      this.branch.parentId = this.selectedBranch.id;
    }
  }

  /**
   * On submit form
   */
  onClickBtnSubmit() {
    if (this.selectedBranch == null || this.selectedBranch == undefined) {
      this.branch.parentId = '';
    } else if (this.selectedBranch != null && this.selectedBranch != undefined) {
      this.branch.parentId = this.selectedBranch.id;
    }
  }

  /**
   * On click button add branch
   */
  onCreateBranch() {
    this.uploadMultiFileComponent.uploadFile((attachments) => {
      this.branch.attachments = attachments;
      this.createBranch();
    }, () => {
      this.createBranch();
    });
  }

  /**
   * Call create branch service and push data to server.
   */
  private createBranch() {
    this.branchService.createBranch(this.branch, () => { },
      this.onAddBrandError.bind(this))
      .subscribe(rs => {
        if (rs && rs.success) {
          this.show = false;
          this.toastr.success(rs.message);
          this.router.navigate(['/home-enterprise/branches']);
        }
      });
  }

  private onAddBrandError(rs: any) {
    if (!rs.success) {
      switch (rs.code) {
        case '0x00118':
          this.certificateNoExistingHanlder(rs);
          break;
        case '0x00117':
          this.taxNoExistingHanlder(rs);
          break;
        case '0x00103':
          this.toastr.error(rs.message);
          break;
        default:
          this.notificationService.notify(Utils.toErrorMessage(rs, this.message.getMessage('messages.error_message')));
          break;
      }
    }
  }

  private certificateNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.certificateNo.setErrors({ incorrect: true, duplicate: true });
    Utils.forcusAndScrollToElement(this.certificateNoEl);
  }

  private taxNoExistingHanlder(rs: any): void {
    this.ngForm.form.controls.taxCode.setErrors({ incorrect: true, duplicate: true });
    document.getElementById('taxCodeId').focus();
  }

  /**
   * Close adding branch dialog
   */
  onNoClick() {
    if (this.isFormChanging || this.uploadMultiFileComponent.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.router.navigate(['/home-enterprise/branches']);
        }
        dialogRe.close();
      });
    } else {
      this.router.navigate(['/home-enterprise/branches']);
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.isFormChanging && this.show && tenantId != null)
      || (this.uploadMultiFileComponent.isFormChanging && this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        const result = rs.data;
        this.certificateType = result;
        this.filteredCertificateType.next(this.certificateType.slice());
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        const result = rs.data;
        this.representativeCertificateType = result;
        this.filteredRepresentativeCertificateType.next(this.representativeCertificateType.slice());
      }
    });
  }

  onAttachmentChange(event) {
    this.isFormChanging = event;
  }

  getEnterpriseTypeOptions(options) {
    return this.customerFilter.filterOptionsData(options);
  }
}



